import React, {useContext} from "react";
import {Route,useRouteMatch} from "react-router-dom";
import DashboardAdviser from "../views/adviser/DashboardAdviser";
import CotizacionVehiculo from "../components/Formularios/Cotizar/VehiculoForm/CotizarPage";
import ConfirmarVehiculo from "../components/Formularios/Confirmar/VehiculoForm/ConfirmarPage";
import CotizacionCombinado from "../components/Formularios/Cotizar/CombinadoForm/CotizarPage";
import CotizacionMotovehiculo from "../components/Formularios/Cotizar/MotovehiculoForm/CotizarPage";
import CotizacionMicroseguro from "../components/Formularios/Cotizar/MicrosegurosForm/CotizarPage";
import EmisionVehiculo from "../components/Formularios/Emision/VehiculoForm/EmisionPage";
import EmisionCombinado from "../components/Formularios/Emision/CombinadoForm/EmisionPage";
import EmisionMicroseguro from "../components/Formularios/Emision/MicrosegurosForm/EmisionPage";
import EmisionMotovehiculo from "../components/Formularios/Emision/MotovehiculoForm/EmisionPage";
import Documentacion from "../views/adviser/Documentacion";
import {compose} from "recompose";
import {withIndicatorsContextProvider, withIndicatorsContextReady} from "../context/AdviserContext/IndicatorsContext";
import AdviserContext, {withAdviserContextProvider, withAdviserContextReady} from "../context/AdviserContext";
import {withDiscountsContextProvider, withDiscountsContextReady} from "../context/DiscountsContext";
import {withCotizarContextProvider, withCotizarContextReady} from "../context/CotizarContext";
import ProtectedUserRoute from "../components/ProtectedUserRoute";

const AdviserRoutes = () => {
    const {path} = useRouteMatch();
    const {productScope} = useContext(AdviserContext);

    return (
        <>
            <Route path={`${path}/dashboard`} component={DashboardAdviser}/>

            {/*Cotizar*/}
            <ProtectedUserRoute
                path={`${path}/cotizar/vehiculo`} component={CotizacionVehiculo}
                allowed={productScope.includes("vehiculo")}
            />
            <ProtectedUserRoute
                path={`${path}/cotizar/combinado`} component={CotizacionCombinado}
                allowed={productScope.includes("combinado")}
            />
            <ProtectedUserRoute
                path={`${path}/cotizar/microseguro`} component={CotizacionMicroseguro}
                allowed={productScope.includes("microseguro")}
            />
            <ProtectedUserRoute
                path={`${path}/cotizar/motovehiculo`} component={CotizacionMotovehiculo}
                allowed={productScope.includes("motovehiculo")}
            />

            {/*Emitir*/}
            <ProtectedUserRoute
                path={`${path}/emitir/vehiculo`} component={EmisionVehiculo}
                allowed={productScope.includes("vehiculo")}
            />
            <ProtectedUserRoute
                path={`${path}/emitir/combinado`} component={EmisionCombinado}
                allowed={productScope.includes("combinado")}
            />
            <ProtectedUserRoute
                path={`${path}/emitir/microseguro`} component={EmisionMicroseguro}
                allowed={productScope.includes("microseguro")}
            />
            <ProtectedUserRoute
                path={`${path}/emitir/motovehiculo`} component={EmisionMotovehiculo}
                allowed={productScope.includes("motovehiculo")}
            />

            {/*Confirmar*/}
            <ProtectedUserRoute
                path={`${path}/confirmar/vehiculo`} component={ConfirmarVehiculo}
                allowed={productScope.includes("vehiculo")}
            />

            {/*Documentación*/}
            {/*Split routes was the only way i found to protect documentation routes for specific products*/}
            {/*<Route path={`${path}/documentacion/:producto`} component={Documentacion}/>*/}
            <ProtectedUserRoute
                path={`${path}/documentacion/vehiculo`} component={Documentacion}
                allowed={productScope.includes("vehiculo")}
            />
            <ProtectedUserRoute
                path={`${path}/documentacion/hogar`} component={Documentacion}
                allowed={productScope.includes("combinado")}
            />
            <ProtectedUserRoute
                path={`${path}/documentacion/microseguro`} component={Documentacion}
                allowed={productScope.includes("microseguro")}
            />
            <ProtectedUserRoute
                path={`${path}/documentacion/motovehiculo`} component={Documentacion}
                allowed={productScope.includes("motovehiculo")}
            />
            <ProtectedUserRoute
                path={`${path}/documentacion/otros`} component={Documentacion}
                allowed={productScope.includes("otros")}
            />
            <ProtectedUserRoute
                path={`${path}/documentacion/prevencion`} component={Documentacion}
                allowed={productScope.includes("prevencion")}
            />
        </>
    );
};

export default compose(
    withAdviserContextProvider,
    withAdviserContextReady,
    withIndicatorsContextProvider,
    withIndicatorsContextReady,
    withDiscountsContextProvider,
    withDiscountsContextReady,
    withCotizarContextProvider,
    withCotizarContextReady,
)(AdviserRoutes);